module.exports = __webpack_public_path__ + "img/img11.43f6c73.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/06/img11.png
// module id = 251
// module chunks = 0